import * as React from 'react';

import type { PostType } from '@blockworks/platform/api/strapi';

import RecentResearch from '@/components/sections/right/recent-research';

type RecentResearchFetchableProps = {
    hideHeader?: boolean;
    className?: string;
    recentArticles: PostType[] | null;
};

const RecentResearchFetchable = ({ recentArticles, hideHeader, className }: RecentResearchFetchableProps) => {
    if (!recentArticles || recentArticles?.length === 0) {
        return null;
    }

    return (
        <>
            {recentArticles.map(article => (
                <RecentResearch
                    key={article.slug}
                    recentResearch={article}
                    hideHeader={hideHeader}
                    className={className}
                />
            ))}
        </>
    );
};

export default RecentResearchFetchable;
